import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthorizationService } from 'src/app/authorization/services/authorization.service';
import { User } from 'src/app/core/objects/user';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ProjectService } from 'src/app/core/services/project.service';
import { UserApiService } from 'src/app/core/services/user-api.service';
import { WhiteLabelService } from 'src/app/core/services/white-label.service';
import { CompanyBranding, SharedProject } from 'src/app/core/types';
import { PdfFromProjectService } from './../../core/services/pdf-from-project.service';
import { ProjectApiService } from './../../core/services/project-api.service';
import { SharedProjectService } from './../../core/services/shared-project.service';
import { UserService } from './../../core/services/user.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'gl-open-shared-project',
    templateUrl: './open-shared-project.component.html',
    styleUrls: ['./open-shared-project.component.scss'],
    standalone: false
})
export class OpenSharedProjectComponent implements OnDestroy {
  public sharedProject: SharedProject;
  public companyBranding: CompanyBranding;
  public logo: CompanyBranding;
  public user: User;
  private subscriptions: Subscription[] = [];

  constructor(
    public authorizationService: AuthorizationService,
    private sharedProjectService: SharedProjectService,
    private projectApiService: ProjectApiService,
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private userApiService: UserApiService,
    private pdfFromProjectService: PdfFromProjectService,
    private navigationService: NavigationService,
    private whiteLabelService: WhiteLabelService,
  ) {
    this.logo = this.whiteLabelService.getState();
    this.subscriptions.push(
      this.sharedProjectService.sharedProject.subscribe((sharedProject: SharedProject) => {
        this.sharedProject = sharedProject;
        if (sharedProject?.project) {
          const { project } = sharedProject;
          this.companyBranding = project.companyBranding;
          if (this.companyBranding) {
            const companyBrandingId = this.companyBranding.clientUrl.split('branding=')[1];
            this.router.navigate([], {
              queryParams: {
                'company-branding': companyBrandingId,
              },
              queryParamsHandling: 'merge',
            });
            this.whiteLabelService.setState(project.companyBranding);
          }
        }
      }),
    );
    this.subscriptions.push(this.userApiService.getUser().subscribe());
    this.subscriptions.push(this.userService.user.subscribe((user: User) => (this.user = user)));

    this.projectService.setState(this.sharedProject?.project);
  }

  public ngOnDestroy() {
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  public closeSharedView() {
    this.sharedProjectService.endSharedView();
    this.navigationService.navigateToHomepage();
  }

  public editSharedProject() {
    this.projectApiService
      .editSharedProject(this.route.snapshot.queryParams.id as string)
      .subscribe(() => this.closeSharedView());
  }

  public generatePDF() {
    this.sharedProjectService.currentVersionNumber.pipe(take(1)).subscribe((versionNumber) => {
      this.pdfFromProjectService
        .generateSharePDF(this.sharedProject, 0, null, null, versionNumber)
        .subscribe();
    });
  }

  public goToLogin() {
    const link = `${location.pathname}?id=${this.route.snapshot.queryParams.id as string}`;
    const authChange = this.userService.user.subscribe((d) => {
      if (d.email) {
        this.router.navigateByUrl(link);
        authChange.unsubscribe();
      }
    });

    this.navigationService.navigateToLogin();
  }
}
